"use client";
import { j as e } from "./jsx-runtime-CJ-St4mQ.mjs";
import { forwardRef as i, useContext as n } from "react";
import { T as o } from "./TableContext-DbkGJo7V.mjs";
const m = i(
  function(r, t) {
    const { size: s } = n(o);
    return /* @__PURE__ */ e.jsx(o.Provider, { value: { isHeader: !1, size: s }, children: /* @__PURE__ */ e.jsx("tbody", { ref: t, ...r }) });
  }
);
export {
  m as TableBody
};
